export default "__VITE_ASSET__Cd_u_go$__"